module.exports = __webpack_public_path__ + "static/RST-Verschlusskappe-USB-edcf3687208a264acf3a4c2fdbe505e1.jpg";